const cache = new Map<string, Promise<string>>();

let wasClearedOnce = false;

export const getSvgContent = (url: string): Promise<string> => {
	const cached = cache.get(url);

	if (cached) {
		return cached;
	}

	const promise = fetch(url)
		.then(response => {
			if (!response.ok) {
				throw new Error(`SvgCache: unable to load SVG ${url}, status: ${response.status}`);
			}

			return response.text();
		})
		.catch(error => {
			cache.delete(url);
			throw error;
		});

	cache.set(url, promise);

	return promise;
};

export const clearSvgCacheOnce = (): void => {
	if (wasClearedOnce) {
		return;
	}

	wasClearedOnce = true;
	cache.clear();
};
